import { CardHeader, Grid, Typography } from "@mui/material";
import React from "react";

const Identifiant = ({ refer, identif, prefix }) => {
  return (
    <>
      <Grid
        border={"1px rgba(11, 93, 208,0.25) solid "}
        boxShadow="0px 1px 2px rgba(7,71,161,0.25)"
        m={0.5}
      >
        <CardHeader
          title="Identifiant"
          titleTypographyProps={{ variant: "body1" }}
          subheaderTypographyProps={{ variant: "caption" }}
          subheader={
            <Grid ml={1}>
              <Typography>
                <b>Reference du dossier :</b>
                {` ${refer || ""} `}
              </Typography>
              <Typography>
                <b>Nom:</b>
                {`${identif?.nom || ""} `}
              </Typography>
              <Typography>
                {prefix !== "CI" && (<b>Poste :</b>)}{`${identif?.poste || ""} `}
              </Typography>
            </Grid>
          }
        />
      </Grid>
    </>
  );
};

export default Identifiant;
